import { UserCollection } from "@lifeat/shared/data-models/user/UserEntity";
import { PlannerDynamicSidebarContentType } from "@lifeat/shared/planner/PlannerTypes";
import { AppMode, FocusModeSidebarContentType } from "@lifeat/shared/system/AppModeTypes";
import { DatabaseService } from "@service/DatabaseService";

export const updateLastViewedAppMode = async (uid: string, content: AppMode) => {
    const db = DatabaseService();
    const node = UserCollection.at(uid).at("lastViewedContent").at("appMode").node;
    return await db.set(node, content);
};

export const updateLastViewedFocusSidebarContent = async (uid: string, content: FocusModeSidebarContentType) => {
    const db = DatabaseService();
    const node = UserCollection.at(uid).at("lastViewedContent").at("focusSidebar").node;
    return await db.set(node, content);
};

export const updateLastViewedPlannerSidebarContent = async (uid: string, content: PlannerDynamicSidebarContentType) => {
    const db = DatabaseService();
    const node = UserCollection.at(uid).at("lastViewedContent").at("plannerSidebarContent").node;
    return await db.set(node, content);
};
